import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCompany } from "@/context/CompanyContext";
import { avatarFor } from "@/lib/utils-tg";

/**
 * Small inline display of tagged teammates. Shows up-to-3 avatar bubbles plus
 * a "+N" overflow chip when there are more.
 */
export default function ParticipantBubbles({ ids = [], size = 22 }) {
  const { active } = useCompany();
  const [members, setMembers] = useState({});

  useEffect(() => {
    let mounted = true;
    if (!active?.id || ids.length === 0) return;
    api.get(`/companies/${active.id}/members`)
      .then((r) => {
        if (!mounted) return;
        const map = {};
        (r.data || []).forEach((m) => {
          if (m.user_id) map[m.user_id] = m;
        });
        setMembers(map);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, [active?.id, ids.length]);

  if (!ids.length) return <span className="text-slate-400">—</span>;
  const shown = ids.slice(0, 3);
  const overflow = ids.length - shown.length;

  return (
    <span className="inline-flex items-center" data-testid="participant-bubbles">
      {shown.map((id, i) => {
        const m = members[id];
        const name = m?.name || m?.work_email || "?";
        return (
          <img
            key={id}
            src={m?.avatar_url || avatarFor(name)}
            alt={name}
            title={name}
            className="rounded-full border-2 border-white bg-emerald-50"
            style={{
              width: size,
              height: size,
              marginLeft: i === 0 ? 0 : -size * 0.35,
              zIndex: shown.length - i,
            }}
            onError={(e) => { e.currentTarget.src = avatarFor(name); }}
          />
        );
      })}
      {overflow > 0 && (
        <span
          className="rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-semibold flex items-center justify-center border-2 border-white"
          style={{ width: size, height: size, marginLeft: -size * 0.35 }}
        >
          +{overflow}
        </span>
      )}
    </span>
  );
}
